import Requests from "../../../../services/requests";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import MenuLateral from "../../../../components/menu-lateral";
import MenuHeader from "../../../../components/menu-header";
import "./styles/rtcInfo.css";

export function RTCInfo({ token }) {
    let config = { headers: { "x-access-token": token } };
    let { id } = useParams();

    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            try {
                await Requests.getAllRTCById(id, config).then((res) => {
                    setData(res);
                });
            } catch (error) {
                console.error(error);
            } finally {
                setIsLoading(false);
            }
        }
        fetchData();
    }, []);

    if (isLoading) {
        return (
            <div className="loading">
                <p>Loading...</p>
            </div>
        );
    }

    const formatDate = (date) => {
        const dataBanco = new Date(date);
        const dataFormatada = dataBanco.toLocaleDateString();
        return dataFormatada;
    };

    console.log(data);

    return (
        <div>
            <div className="container-rtc-info">
                <header className="menu-header">
                    <MenuHeader />
                </header>
                <div className="menu-lateral-wrapper">
                    <MenuLateral />
                </div>
                <div className="title-container">
                    <h1 className="title">Inspeção de RTC</h1>
                </div>
                {data.map((check, i) => {
                    return (
                        <main className="datagrid-container-rtc">
                            <div className="table-content-rtc">
                                <div key={i}>
                                    <thead>
                                        <tr>
                                            <th>Gerência</th>
                                            <th>Local</th>
                                            <th>Data</th>
                                            <th>Nome</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <td>
                                            {check.gerencia
                                                ? check.gerencia
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.area
                                                ? check.area
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.data_inspecao
                                                ? formatDate(
                                                      check.data_inspecao
                                                  )
                                                : "Não informado"}
                                        </td>
                                        <td>
                                            {check.nome_cargo
                                                ? check.nome_cargo
                                                : "Não informado"}
                                        </td>
                                    </tbody>
                                </div>
                                <br></br>
                                <br></br>
                                <div key={i}>
                                    {check.rtcs.length > 0 &&
                                        Array.isArray(check.rtcs[0]) &&
                                        check.rtcs[0].map((rtc, i) => {
                                            return (
                                                <div key={i}>
                                                    <thead>
                                                        <tr>
                                                            <th>Ação</th>
                                                            <th>Descrição</th>
                                                            <th>Responsável</th>
                                                            <th>
                                                                Itens status
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <td>
                                                            {rtc.acao
                                                                ? rtc.acao
                                                                : "Não informado"}
                                                        </td>
                                                        <td>
                                                            {rtc.descricao
                                                                ? rtc.descricao
                                                                : "Não informado"}
                                                        </td>
                                                        <td>
                                                            {rtc.responsavel
                                                                ? rtc.responsavel
                                                                : "Não informado"}
                                                        </td>
                                                        <td>
                                                            {rtc.itens_status
                                                                ? rtc.itens_status
                                                                : "Não informado"}
                                                        </td>
                                                    </tbody>
                                                </div>
                                            );
                                        })}
                                    ;
                                    {check.rtcs.length > 0 &&
                                    typeof check.rtcs[0] === "object" ? (
                                        <div>
                                            <thead>
                                                <tr>
                                                    <th>Ação</th>
                                                    <th>Descrição</th>
                                                    <th>Responsável</th>
                                                    <th>Itens status</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <td>
                                                    {check.rtcs[0].acao
                                                        ? check.rtcs[0].acao
                                                        : "Não informado"}
                                                </td>
                                                <td>
                                                    {check.rtcs[0].descricao
                                                        ? check.rtcs[0]
                                                              .descricao
                                                        : "Não informado"}
                                                </td>
                                                <td>
                                                    {check.rtcs[0].responsavel
                                                        ? check.rtcs[0]
                                                              .responsavel
                                                        : "Não informado"}
                                                </td>
                                                <td>
                                                    {check.rtcs[0].itens_status
                                                        ? check.rtcs[0]
                                                              .itens_status
                                                        : "Não informado"}
                                                </td>
                                            </tbody>
                                        </div>
                                    ) : (
                                        <h2 className="subtitle-sem-espe">Não há especificações</h2>
                                    )}
                                </div>
                            </div>
                        </main>
                    );
                })}
            </div>
        </div>
    );
}
